var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplyAllIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.806.267a.857.857 0 0 0-1.21-.032L.532 5.043a1.716 1.716 0 0 0 0 2.487l5.062 4.808a.857.857 0 0 0 1.18-1.243L1.711 6.286l5.062-4.808A.857.857 0 0 0 6.806.267zm5.095.875c0-.45-.265-.86-.679-1.043a1.147 1.147 0 0 0-1.229.193L4.277 5.436a1.15 1.15 0 0 0-.379.85c0 .326.14.633.38.85l5.715 5.145c.336.304.818.379 1.229.193.41-.186.679-.593.679-1.043V9.144h1.143a3.43 3.43 0 0 1 3.43 3.43c0 1.086-.458 1.711-.794 2.026-.196.182-.35.428-.35.696 0 .39.315.704.704.704.1 0 .2-.021.29-.068a6.993 6.993 0 0 0 3.58-6.216 6.288 6.288 0 0 0-6.288-6.287H11.9V1.142z",
    fill: "#0A68FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyAllIcon);
export default ForwardRef;